import React, { useEffect, useState } from 'react'
import NumberField from '../../elements/form/NumberField'
import ModalActionButton from '../../elements/ModalActionButton'
import { useDispatch, useSelector } from 'react-redux'
import TextField from '../../elements/form/TextField'
import AutocompleteSelect from '../../elements/form/AutocompleteSelect'
import PlusIcon from '../../elements/icons/PlusIcon'
import { fetchStaff } from '../../../store/actions/staffActions'
import InlinePreloader from '../../elements/InlinePreloader'
import { createHouseBlock } from '../../../store/actions/housingActions'
import TrashIcon from '../../elements/icons/TrashIcon'
import { ERROR } from '../../../store/types'

const NewBlock = ({houseId, closeFunction, reload}) => {
    const [blockPayload, setBlockPayload] = useState({})
    const [validationErrors, setValidationErrors] = useState({})
    const dispatch = useDispatch()
    const housingSelector = useSelector(state => state.housing)
    const staffSelector = useSelector(state => state.staff)
    const [houseParents, setHouseParents] = useState([''])

    useEffect(() => {
      dispatch(fetchStaff(`onboarded=true`, 0, 0))
    
      return () => {
        
      }
    }, [dispatch])

    const updateHouseParent = (index, staffId) => {
        const temp = [...houseParents]
        temp[index] = staffId
        setHouseParents(temp)
    }

    const addHouseParent = () => {
        const temp = [...houseParents]
        temp.push('')
        setHouseParents(temp)
    }

    const removeHouseParent = (index) => {
        const temp = [...houseParents]
        temp.splice(index, 1)
        setHouseParents(temp)
    }

    const validateForm = () => {
        let errors = {}

        if(!blockPayload.label || blockPayload.label === ''){
            errors.label = true
        }

        if(!blockPayload.maxStudentCount || blockPayload.maxStudentCount === ''){
            errors.maxStudentsCount = true
        }

        if(houseParents.length > 1){
            houseParents.forEach((element, elementIndex) => {
                if(element === ''){
                    errors[`parent-${elementIndex}`] = true
                }
            });
        } 
    
        setValidationErrors(errors)
    
        return errors
    }

    const pushBlock = () => {
        if (Object.values(validateForm()).includes(true)) {
            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            })
            return
        }

        const payload = {
            house: houseId,
            ...blockPayload
        }

        if(houseParents.length > 0 && houseParents[0] !== ''){
            payload.houseParents = houseParents
        }
        dispatch(createHouseBlock(payload)).then(()=>{reload()})
    }

    return (
        <div className='w-full'>
            <div className=''>
                <TextField
                    inputLabel="Block Label" 
                    inputPlaceholder={`Eg: A`}
                    fieldId="block-label" 
                    inputType="text" 
                    requiredField={true}
                    preloadValue={blockPayload.label || ''}
                    hasError={validationErrors && validationErrors.label} 
                    returnFieldValue={(value)=>{setBlockPayload({...blockPayload, label: value})}}
                />
            </div>
            <div className='mt-4 relative'>
                <NumberField
                    inputType="number" 
                    fieldId={`max-students`}
                    inputLabel="Maximum students for this block" 
                    requiredField={true}
                    preloadValue={blockPayload?.maxStudentCount || ''}
                    hasError={validationErrors.maxStudentsCount} 
                    returnFieldValue={(value)=>{setBlockPayload({...blockPayload, maxStudentCount: value})}}
                />
                <p className='text-xs text-gray-500 mt-[5px]'>The number of students in a block can not be above the amount you provide here.</p>
            </div>

            <h3 className='mt-4 font-[500]'>House parents</h3>
            <p className='text-sm'>Select up to two house parents (administrators) for this block. (You can do this later if you are not ready now)</p>

            {staffSelector?.loadingStaff 
            ? 
                <InlinePreloader />
            : 
                <>
                    {staffSelector?.staffMembers?.staff?.length > 0 && houseParents.map((parent, parentIndex)=>(<div key={parentIndex} className='mt-4 relative'>
                        {parentIndex > 0 && 
                            <button onClick={()=>{removeHouseParent(parentIndex)}} className='absolute right-0 top-0 p-1 z-50 rounded bg-transparent mb-[10px] hover:bg-vcm-light-purple hover:bg-opacity-20 transition duration-200 text-gray-400 hover:text-vcm-purple'>
                                <TrashIcon className={`w-4 h-4`} />
                            </button>
                        }
                        <AutocompleteSelect
                            selectOptions = {staffSelector?.staffMembers?.staff}
                            inputLabel = "House Parent"
                            requiredField={true}
                            titleField = "fullName"
                            displayImage = {false}
                            imageField = ""
                            fieldId = {`house-parent-${parentIndex}`}
                            preSelected={parent || ''}
                            preSelectedLabel='_id'
                            hasError = {validationErrors && validationErrors[`parent-${parentIndex}`]}
                            returnFieldValue={(value)=>{updateHouseParent(parentIndex, value._id)}}
                        />
                    </div>))}
                    
                    {staffSelector?.staffMembers?.staff?.length === 0 && 
                        <div className='w-full mt-[20px] p-[15px] bg-gray-50 border border-gray-400 rounded-[8px] bg-opacity-'>
                            <h3 className='text-sm text-gray-600 font-[500] tracking-tight'>No eligible staff found</h3>
                            <p className='text-sm font-[500] text-gray-500'>The staff must be fully onboarded on this system and be enrolled as a full time employee</p>
                        </div>
                    }
                </>
            }

            {houseParents.length < 2 && staffSelector?.staffMembers?.staff?.length > 0  && <div className='mt-3'>
                <button onClick={()=>{addHouseParent()}} className='text-gray-600 bg-gray-200 rounded-[8px] p-3 transition duration-200 hover:bg-gray-100 border border-dashed border-gray-600 hover:text-vcm-dark-gray text-sm flex items-center gap-x-1'>
                    <PlusIcon className={`w-5 h-5`} /> Add another parent
                </button>
            </div>}

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Create Block`}
                    buttonAction={()=>{pushBlock()}}
                    processing={housingSelector.creatingBlock}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={closeFunction}
                >
                    Close
                </button>
                
            </div>
        </div>
    )
}

export default NewBlock
